import PropTypes from 'prop-types'
import { Button } from '@raspberrypifoundation/design-system-react'
import { useTranslation } from 'react-i18next'
import './NextProjectCard.scss'

const NextProjectCard = ({ project }) => {
  const { i18n, t } = useTranslation()

  return (
    <div
      className={'sc-pr-next-project__container'}
      data-testid="next-project-card"
    >
      <div className={'sc-pr-next-project__summary'}>
        <h1 className="sc-pr-next-project__summary-title">{project.title}</h1>
      </div>
      <div className="sc-pr-next-project__details-inner">
        <img
          alt=""
          className={'sc-pr-next-project__image'}
          src={project.heroImage}
        />
        <div className="sc-pr-next-project__description">
          <p>{project.description}</p>

          <Button
            className={'sc-pr-next-project__button'}
            text={t('pathway.button.start-project')}
            href={`/${i18n.language}/projects/${project.repositoryName}`}
            fullWidth
          />
        </div>
      </div>
    </div>
  )
}

NextProjectCard.propTypes = {
  project: PropTypes.object.isRequired,
}

export default NextProjectCard
